import buildQuery from 'odata-query';
import { ApiRequest } from './ApiUtils';

const UtilityBuilder = (per_page, page, expand, orderByInfo, orderByDirection) => {

    //Building the expand object
    const data = {}
    let mappedOrderBy = false
    expand.forEach((exp) => {
        data[Object.keys(exp)] = orderByInfo !== undefined ? exp[Object.keys(exp)].forEach((field) => {
            if (field === orderByInfo.field) {
                mappedOrderBy = true
                return { orderBy: ` ${(orderByInfo.field).split('_')[0]} ${orderByDirection}` }
            }
        }) : {}
    })


    const orderBy = orderByInfo !== undefined && !mappedOrderBy ? [`${orderByInfo.field} ${orderByDirection}`] : undefined

    return {
        skip: per_page * Math.abs((page)),
        count: true,
        top: per_page,
        expand: data,
        orderBy
    }
}

const buildExpandTree = (expandObject, depth, parent = null, acc = {}) => {
    if (!Array.isArray(expandObject)) {
        for (const prop in expandObject) {
            if (expandObject[prop].expand) {
                const _parent = `${parent ? parent + "/" : ""}${prop}`;
                acc = buildExpandTree(expandObject[prop].expand, depth + 1, _parent, acc);
            } else if (expandObject[prop].select) {
                acc[prop] = {
                    depth,
                    select: expandObject[prop].select,
                    tree: `${parent ? parent + "/" : ""}${prop}`
                };
            }
        };
    } else {
        expandObject.forEach((item) => buildExpandTree(item, depth, parent, acc));
    };
    return acc;
};

const traverseExpander = (expandObject, orderByField, orderByTable, orderByDir = 'asc') => {
    if (!Array.isArray(expandObject)) {
        for (const prop in expandObject) {
            if (expandObject[prop].expand) {
                traverseExpander(expandObject[prop].expand, orderByField, orderByTable, orderByDir);
            }
            // else if (expandObject[prop].select) {
            //     if (prop === orderByTable) {
            //         debugger;
            //         expandObject[prop].orderBy = expandObject[prop].select.filter(
            //             field => field === orderByField
            //         ).map(r => `${orderByField} ${orderByDir}`);
            //     }
            // }
        }
    } else {
        expandObject.forEach((item) => traverseExpander(item, orderByField, orderByTable, orderByDir = 'asc'))
    };
    return expandObject;
};

const UtilityBuilderNested = (per_page, page, expand, orderByInfo, orderByDirection) => {

    //Building the expand object
    let mappedOrderBy = false
    let buildExpand = JSON.parse(expand)
    if (orderByInfo !== undefined && orderByInfo.field.split('_').length > 1) {
        Object.keys(buildExpand).forEach((primaryExpand) => {
            //Checking if the field belong to the primary
            if (primaryExpand === orderByInfo.field.split('_')[1]) {
                mappedOrderBy = true
                buildExpand[primaryExpand] = { ...buildExpand[primaryExpand], "orderby": [`${orderByInfo.field.split('_')[0]} ${orderByDirection}`] }
            } else { //Field belongs to the nested Expand
                buildExpand[primaryExpand].expand.forEach((secondaryExpand, si) => {
                    if (buildExpand[primaryExpand].expand[si][orderByInfo.field.split('_')[1]] !== undefined)
                        Object.keys(buildExpand[primaryExpand].expand[si]).forEach((element, ei) => {
                            //If Key Match the expand name than 
                            Object.keys(buildExpand[primaryExpand].expand[si][element]).forEach((select, selecti) => {
                                Object.keys(buildExpand[primaryExpand].expand[si][element][select]).forEach(field => {
                                    if (buildExpand[primaryExpand].expand[si][element][select][field] === orderByInfo.field.split('_')[0]) {
                                        mappedOrderBy = true
                                        buildExpand[primaryExpand].expand[si][element] = { ...buildExpand[primaryExpand].expand[si][element], "orderby": [`${buildExpand[primaryExpand].expand[si][element][select]} ${orderByDirection}`] }
                                    }
                                })
                            })
                        })
                })
            }
        })
    }

    const orderBy = orderByInfo !== undefined && !mappedOrderBy ? [`${orderByInfo.field} ${orderByDirection}`] : undefined

    return {
        skip: per_page * Math.abs((page)),
        count: true,
        top: per_page,
        expand: buildExpand,
        orderBy
    }
}

const UtilityBuilderNestedv2 = (per_page, page, expand, orderByInfo, orderByDirection) => {

    //Building the expand object
    let expandTree = null;
    let mappedOrderBy = false;
    let orderByField, orderByTable;
    let buildExpand = JSON.parse(expand)
    if (orderByInfo !== undefined && orderByInfo.field.split('_').length > 1) {
        [orderByField, orderByTable] = orderByInfo.field.split('_');
        buildExpand = traverseExpander(buildExpand, orderByField, orderByTable, orderByDirection);
        expandTree = buildExpandTree(buildExpand, 0);
        mappedOrderBy = true;
    }

    let orderBy = orderByInfo !== undefined && !mappedOrderBy ? [`${orderByInfo.field} ${orderByDirection}`] : undefined;

    if (!orderBy && expandTree) {
        orderBy = `${expandTree[orderByTable].tree}/${orderByField} ${orderByDirection}`;
    };

    return {
        skip: per_page * Math.abs((page)),
        count: true,
        top: per_page,
        expand: buildExpand,
        orderBy
    }
}


const UtilityBuilderNestedv3 = (per_page, page, expand, orderByInfo, orderByDirection, filters = [], defaultFilters = []) => {

    //Building the expand object
    console.log("V3")
    let expandTree = null;
    let mappedOrderBy = false;
    let orderByField, orderByTable;
    let buildExpand = expand;
    let searchExpand = expand;
    if (orderByInfo !== undefined && orderByInfo.field.split('_').length > 1) {
        [orderByField, orderByTable] = orderByInfo.field.split('_');
        buildExpand = traverseExpander(buildExpand, orderByField, orderByTable, orderByDirection);
        expandTree = buildExpandTree(buildExpand, 0);
        mappedOrderBy = true;
    };
    let orderBy;
    if (mappedOrderBy) {
        orderBy = `${expandTree[orderByTable].tree}/${orderByField} ${orderByDirection}`;
    } else if (orderByInfo && !mappedOrderBy) {
        orderBy = [`${orderByInfo.field} ${orderByDirection}`];
    } else {
        // leave orderBy as null;
    };

    const gatherSearchField = (column, searchExpand) => {
        if (column.field.split("_").length > 1) {
            const [searchField, searchTable] = column.field.split('_');
            const searchExpandData = traverseExpander(searchExpand, searchField, searchTable, orderByDirection);
            const searchTree = buildExpandTree(searchExpandData, 0);
            try {
                return `${searchTree[searchTable].tree}/${searchField}`;
            } catch (e) {
                debugger
            }
            return `${searchTree[searchTable].tree}/${searchField}`;
        } else {
            return column.field;
        }
    };
    /* eslint-disable-next-line array-callback-return */
    let _filters = filters.map(r => {
        if (r.defaults) {
            // do nothing;
            return null;
        } else {
            const field = gatherSearchField(r.column, searchExpand);
            switch (r.column.type) {
                case 'string':
                    return { [field]: { contains: r.value } }
                case 'numeric':
                    return { [field]: { eq: r.value * 1 } }
                case 'currency':
                    return { [field]: { eq: r.value * 1 } }
                case 'boolean':
                    return { [field]: { eq: r.value === 2 } }
                case 'date':
                    return { [field]: r.value }
                case 'guid':
                    if (!r.value || r.value.length !== 36) {
                        // do nothing;
                        return null;
                    } else {
                        return { [field]: { eq: { type: 'guid', value: r.value } } };
                    }
                default:
                    return { [field]: { contains: r.value } }
            };
        }
    }).filter(r => r != null);

    /* eslint-disable-next-line array-callback-return */
    let _defaultFilters = defaultFilters.map(r => {
        if (r.defaults) {
            // do nothing;
            return null;
        } else {
            const field = gatherSearchField(r.column, searchExpand);
            switch (r.column.type) {
                case 'string':
                    return { [field]: { contains: r.value } }
                case 'numeric':
                    return { [field]: { eq: r.value * 1 } }
                case 'currency':
                    return { [field]: { eq: r.value * 1 } }
                case 'boolean':
                    return { [field]: { eq: r.value === 2 } }
                case 'date':
                    return { [field]: r.value }
                case 'guid':
                    if (!r.value || r.value.length !== 36) {
                        // do nothing;
                        return null;
                    } else {
                        return { [field]: { eq: { type: 'guid', value: r.value } } };
                    }
                default:
                    return { [field]: { contains: r.value } }
            };
        }
    }).filter(r => r != null);

    return {
        skip: per_page * Math.abs((page)),
        count: true,
        top: per_page,
        expand: buildExpand,
        orderBy,
        mappedFilter: _filters,
        mappedDefaultFilters: _defaultFilters
    }
}

const unCoupleExpandsFromDefaults = (resource) => {
    const returnObj = {};
    Object.keys(resource).forEach(r => {
        if (r.includes("_")) {
            returnObj[r.split("_")[0]] = resource[r];
        } else {
            returnObj[r] = resource[r];
        };
    });
    return returnObj;
};

const buildCollectionFilter = ({ field, filters, buildExpand }) => {
    let colFilter;
    const checkForField = filters.find(r => r.column && r.column.field === field);
    if (checkForField) {
        filters = [...filters.filter(r => (r.column && r.column.field !== field) || !r.column)];
        colFilter = buildExpand(checkForField.value);
    } else {
        const checkForDefault = filters.find(r => r.defaults && Object.keys(r.defaults).includes(field));
        if (checkForDefault) {
            colFilter = buildExpand(checkForDefault.defaults[field]);
        }
    }

    return {
        filters,
        collectionFilter: colFilter ? colFilter : null
    }
};

function upackDefaultFilters(filters, model) {
    let dFilters = [];
    const isDefaults = filters.find(r => r.defaults);

    if (isDefaults) {
        const defaults = isDefaults.defaults;
        dFilters = Object.entries(defaults).map(r => {
            const [key, value] = r;
            const column = model.columns.find(r => r.field === key);
            let val;
            if (column) {
                switch (column.type.toLowerCase()) {
                    case "boolean":
                        val = value === true ? 2 : false;
                        break;
                    default:
                        val = value
                }
            }
            return {
                column,
                operator: "=",
                value: val
            }
        }).filter(r => !!r.column);
    };

    return dFilters;
}

async function gridQuery(page, per_page, orderByInfo, orderByDirection, search, filters, { model, endpoint }) {
    let collectionFilters = [];
    const mappedCollectionFilterFields = [];

    model.collectionFilterAttributes.forEach((item, index) => {
        const colFilter = ODataUtil.buildCollectionFilter({ ...item, filters });
        if(colFilter.collectionFilter) { mappedCollectionFilterFields.push(item.field) };
        collectionFilters = colFilter.collectionFilter ? [...collectionFilters, colFilter.collectionFilter] : collectionFilters;
    });

    let defaultFilters = upackDefaultFilters(filters, model);
    defaultFilters = defaultFilters.filter(r => !mappedCollectionFilterFields.includes(r.column.field));

    filters = filters.filter(r => (r.column && !mappedCollectionFilterFields.includes(r.column.field)) || r.defaults);

    const { skip, count, top, expand, orderBy, mappedFilter, mappedDefaultFilters } = UtilityBuilderNestedv3(
        per_page, page, model.expand, orderByInfo, orderByDirection, filters, defaultFilters
    );

    let filter = {};

    const isDefaults = filters.find(r => r.defaults);
    
    if (isDefaults) {

        const defaults = isDefaults.defaults;

        let defaultFiltersObject = {};
        mappedDefaultFilters.forEach(r => {
            defaultFiltersObject[Object.keys(r)[0]] = r[Object.keys(r)[0]];
        })

        filter = { ...defaultFiltersObject };

        if (defaults.projectId) {
            filter["ProjectId"] = { eq: { type: 'guid', value: defaults.projectId } };
            delete filter.projectId;
        };
    };

    if (collectionFilters.length > 0) {
        filter = {
            ...filter,
            ...collectionFilters.reduce((a, b) => ({ ...a, ...b }), {})
        }
    };

    const allFilters = mappedFilter.reduce((a, b) => ({ ...a, ...b }), filter);
    const params = buildQuery({ 
        count, 
        ...(top && {top}),
        ...(skip && {skip}), 
        orderBy, expand, filter: allFilters 
    });
    
    let data = await ApiRequest(endpoint, params);
    data = model.convertToTableRows(data);
    return data;
}

const ODataUtil = {
    UtilityBuilder,
    UtilityBuilderNested,
    UtilityBuilderNestedv2,
    UtilityBuilderNestedv3,
    unCoupleExpandsFromDefaults,
    buildCollectionFilter,
    buildExpandTree,
    traverseExpander,
    gridQuery
};


export default ODataUtil;
